module.exports = __webpack_public_path__ + "img/background_requeteur.f2bf050a.png";